<div class="widget-container" #KPIHeatMapCharDiv>
    <app-kpi-breakdown-heatmap-chart
    [type]="'widget'"
    [heading]="heading"
    [config]="config"
    [item]="item"
    [pageKey]="pageKey"
    [data]="data"
    [error_name]="error_name"
    >
    </app-kpi-breakdown-heatmap-chart>
</div>
<!-- *ngIf="isDataLoaded"  -->